// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2jFFQ","productName":"Table_productName__1SOLh"};